import { useRouter } from 'next/router';

import { Trans } from '@/components/tools/translation';

const ErrorFallbackGlobal = () => {
    const router = useRouter();
    return (
        <div className="flex min-h-full w-full px-m py-m md:pl-36 md:pr-[5.688rem] xl:px-48">
            <div
                role="alert"
                className="flex min-h-full w-full flex-1 flex-col items-center justify-center space-y-3 rounded bg-white p-8 dark:bg-icoDarkMode-anthracite">
                <span className="text-center">
                    <Trans
                        i18nKey="errors:error_global_unexpected_occured"
                        components={{
                            br: <br />,
                            tag0: (
                                <button
                                    onClick={() => router.reload()}
                                    className="text-icoBlue underline"
                                />
                            )
                        }}
                    />
                </span>
            </div>
        </div>
    );
};

export default ErrorFallbackGlobal;
